module.exports = __webpack_public_path__ + "img/iframe.0c9e3f0b.svg";